/*!
 * Copyright © 2020-2023. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EApiRequestStatus {
  Initial = 'Initial',
  Request = 'Request',
  Success = 'Success',
  Failure = 'Failure',
}
